exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".client-details {\n  max-height: calc(100vh - 180px);\n  overflow: auto; }\n\n@media only screen and (max-width: 600px) {\n  .client-detail-container .subtitle {\n    padding-left: 12px; }\n  .client-detail-container .close {\n    margin-right: 5px; }\n  .client-detail-container .list-tabs {\n    width: 100vw;\n    margin: 0 auto; }\n  .client-detail-container .table-box {\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/detail/index.scss
// module id = 1199
// module chunks = 0